import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="not-found-page">
      <div className="content-wrapper">
        <h1>404 - Page Not Found</h1>
        <p>The page you're looking for doesn't exist.</p>
        <Link to="/" className="goto-btn">
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;